<div class="container mx-auto mt-6">
  <h2 class="text-4xl font-bold text-center text-gray-800 mb-4 uppercase">Dashboard</h2>

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <!-- Welcome Panel -->
    <div class="bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between h-full">
      <div>
        <div class="relative">
          <img src="../../../assets/fondo2.webp" alt="Banner" class="w-full h-40 object-cover rounded-t-lg">
          <div class="absolute top-4 left-4 bg-orange-500 text-white rounded-full p-2">
            <i class="fas fa-user-circle text-4xl"></i>
          </div>
        </div>
        <div class="mt-4 text-center">
          <h1 class="text-2xl font-semibold mb-2">Bienvenido a la herramienta de facturación de UpSpain</h1>
          <p class="text-sm text-gray-600"><i class="fas fa-envelope mr-2"></i>{{ userName }}</p>
          <p class="text-sm text-gray-600"><i class="fas fa-user-tag mr-2"></i>{{ userRole }}</p>
          <p class="mt-4 text-gray-700">Gestiona tus procesos de facturación y proveedores con esta herramienta.</p>
        </div>
      </div>
    </div>

    <!-- Quick Access Panel -->
    <div class="bg-white shadow-lg rounded-lg p-6 grid grid-cols-2 gap-6 h-full">
      <a href="/home/billing-process"
        class="access-panel flex items-center p-4 bg-gray-100 rounded-lg hover:bg-gray-200 cursor-pointer"
        *ngIf="['ROLE_ADMIN'].includes(userRole)">
        <i class="fas fa-file-invoice-dollar text-4xl text-orange-500"></i>
        <span class="ml-4 text-lg font-semibold text-orange-700">Procesos de facturación</span>
      </a>
      <a href="/home/activity-log"
        class="access-panel flex items-center p-4 bg-gray-100 rounded-lg hover:bg-gray-200 cursor-pointer"
        *ngIf="['ROLE_ADMIN', 'ROLE_CONSULTANT'].includes(userRole)">
        <i class="fas fa-calendar-alt text-4xl text-orange-500"></i>
        <span class="ml-4 text-lg font-semibold text-orange-700">Eventos de registro</span>
      </a>
      <a href="/home/biller"
        class="access-panel flex items-center p-4 bg-gray-100 rounded-lg hover:bg-gray-200 cursor-pointer"
        *ngIf="['ROLE_ADMIN', 'ROLE_BILLER'].includes(userRole)">
        <i class="fas fa-users text-4xl text-orange-500"></i>
        <span class="ml-4 text-lg font-semibold text-orange-700">Enviar a un proveedor</span>
      </a>
      <a href="/home/billing"
        class="access-panel flex items-center p-4 bg-gray-100 rounded-lg hover:bg-gray-200 cursor-pointer"
        *ngIf="['ROLE_ADMIN'].includes(userRole)">
        <i class="fas fa-chart-line text-4xl text-orange-500"></i>
        <span class="ml-4 text-lg font-semibold text-orange-700">Enviar a todos</span>
      </a>
    </div>
  </div>

  <!-- Combined Panels for Providers -->
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
    <div class="bg-white shadow-lg rounded-lg p-6 flex flex-col justify-center">
      <div class="text-center">
        <i class="fas fa-users text-5xl text-orange-500"></i>
        <p class="text-md text-gray-600 mt-2">Total Proveedores</p>
        <div *ngIf="isLoading" class="flex justify-center items-center py-2">
          <mat-spinner diameter="35" strokeWidth="3" class="animate-spin"></mat-spinner>
        </div>
        <p *ngIf="!isLoading" class="text-4xl font-semibold text-orange-500">{{ dashboardData.totalProviders || 0 }}</p>
      </div>
    </div>
    <div class="bg-white shadow-lg rounded-lg p-6 flex flex-col justify-center">
      <div class="text-center">
        <i class="fas fa-exclamation-circle text-5xl text-orange-500"></i>
        <p class="text-md text-gray-600 mt-2">Total Fallidos/Pendientes</p>
        <div *ngIf="isLoading" class="flex justify-center items-center py-2">
          <mat-spinner diameter="35" strokeWidth="3" class="animate-spin"></mat-spinner>
        </div>
        <p *ngIf="!isLoading" class="text-4xl font-semibold text-orange-500">{{ dashboardData.totalPendingProviders || 0
          }}</p>
      </div>
    </div>

    <div class="bg-white shadow-lg rounded-lg p-6">
      <h2 class="text-xl font-semibold mb-4 text-center uppercase">Proveedores fallidos y pendientes</h2>
      <div *ngIf="isLoading" class="flex justify-center items-center py-4">
        <mat-spinner diameter="35" strokeWidth="3" class="animate-spin"></mat-spinner>
      </div>
      <div *ngIf="!isLoading">
        <div
          *ngIf="dashboardData.pendingProviders && dashboardData.pendingProviders.length > 0; else noPendingProviders"
          class="grid grid-cols-1 gap-4">
          <div class="p-4 border rounded-lg" *ngFor="let provider of dashboardData.pendingProviders">
            <p><strong>ID:</strong> {{ provider.providerId }}</p>
            <p><strong>Nombre:</strong> {{ provider.providerName }}</p>
            <p><strong>Fecha Inicio:</strong> {{ provider.startDate }}</p>
            <p><strong>Fecha Fin:</strong> {{ provider.endDate }}</p>
            <p><strong>Intentos:</strong> {{ provider.attempts }}</p>
          </div>
        </div>
        <ng-template #noPendingProviders>
          <p class="text-center text-gray-500">No hay proveedores pendientes.</p>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- Billing Processes and Provider Status Panels -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
    <div class="bg-white shadow-lg rounded-lg p-8">
      <h2 class="text-xl font-semibold mb-4 text-center uppercase">Procesos de facturación</h2>
      <div *ngIf="isLoading" class="flex justify-center items-center py-4">
        <mat-spinner diameter="35" strokeWidth="3" class="animate-spin"></mat-spinner>
      </div>
      <div *ngIf="!isLoading" class="grid grid-cols-2 gap-6">
        <div class="text-center">
          <p class="text-4xl font-semibold text-orange-500">{{ dashboardData.totalBillingProcess || 0 }}</p>
          <p>Total Procesos</p>
        </div>
        <div class="text-center">
          <p class="text-4xl font-semibold text-orange-500">{{ dashboardData.totalBillingProcessFinished || 0 }}</p>
          <p>Finalizados</p>
        </div>
        <div class="text-center">
          <p class="text-4xl font-semibold text-orange-500">{{ dashboardData.totalBillingProcessRunning || 0 }}</p>
          <p>En Curso</p>
        </div>
        <div class="text-center">
          <p class="text-4xl font-semibold text-orange-500">{{ dashboardData.totalBillingProcessCanceled || 0 }}</p>
          <p>Procesos Cancelados</p>
        </div>
      </div>
    </div>

    <div class="bg-white shadow-lg rounded-lg p-8">
      <h2 class="text-xl font-semibold mb-4 text-center uppercase">Estado de proveedores</h2>
      <div *ngIf="isLoading" class="flex justify-center items-center py-4">
        <mat-spinner diameter="35" strokeWidth="3" class="animate-spin"></mat-spinner>
      </div>
      <div *ngIf="!isLoading" class="relative">
        <canvas id="otherDataChart"></canvas>
        <div class="absolute top-0 right-0 p-4 text-right">
          <p><strong>Total Proveedores Activos:</strong> {{ dashboardData.activeProviders || 0 }}</p>
          <p><strong>Total Proveedores Inactivos:</strong> {{ dashboardData.inactiveProviders || 0 }}</p>
          <p><strong>Total Proveedores Inactivos por Intentos:</strong> {{ dashboardData.inactiveForAttemptsProviders ||
            0 }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
